import React from 'react'
import styled from 'styled-components'
import ContactBG from '../../../../assets/bg/mobile/bg_contact_220907.png'
import FooterBG from '../../../../assets/bg/mobile/bg_footer.png'
import FooterTitle from '../../../../assets/bg/mobile/bg_footer_title.png'
import PolygonIcon from '../../../../assets/icon/icon_polygon.png'
import { MENU_LIST } from '../../../../mock'
import { Text, View } from '../../../../styles'
import Float from '../../../../styles/float/Float'
import Outer from '../../../../styles/outer/Outer'
import { devices } from '../../../../utils/responsive'

const ContactMobileComponent = () => {
  return (
    <Wrap>
      <div style={{ zIndex: 20 }}>
        <img src={ContactBG} />
        <MailList>
          <a href='mailto:information@stocombine.io'>information@stocombine.io</a>
          <a href='mailto:press_marketing@stocombine.io'>press_marketing@stocombine.io</a>
          <a href='mailto:business_development@stocombine.io'>business_development@stocombine.io</a>
          <a href='mailto:investment@stocombine.io'>investment@stocombine.io</a>
        </MailList>
      </div>
      <Outer style={{ marginTop: '-11%', zIndex: 10 }}>
        <img src={FooterBG} />
        <Float top={'9%'} left={34} w={'23%'}>
          <img src={PolygonIcon} />
        </Float>
        <Float top={'23%'} left={34} w={'82%'}>
          <img src={FooterTitle} />
        </Float>
        <Footer>
          <View className='bottom-menu' direction='column' spacing={9} block>
            <a className='link' href='#mverse'>
              <Text size='lg'>M-Verse</Text>
            </a>
            <a className='link' href='#overview'>
              <Text size='lg'>Overview</Text>
            </a>
            <a className='link' href='#ecosystem'>
              <Text size='lg'>Ecosystem</Text>
            </a>
            <a className='link' href='#service'>
              <Text size='lg'>Service</Text>
            </a>
            <a className='link' href='#download'>
              <Text size='lg'>Download</Text>
            </a>
            <a className='link' href='#team'>
              <Text size='lg'>Team</Text>
            </a>
            <a className='link' href='#contact'>
              <Text size='lg'>Contact us</Text>
            </a>
          </View>

          <View className='info' direction='column' color='#fff' spacing={4}>
            <Text>| M-Verse Co. Ltd</Text>
            <Text>| CEO Stuart S. Lee / Seongsik Kim</Text>
            <Text>
              | Address: #417, 41, Sangnok-ro 16-gil, Suseong-gu, Daegu, Republic of Korea
            </Text>
            <Text>
              | Business registration number: 111 – 81- 35619
            </Text>
          </View>

          <Text block size='lg' color={'white-color'}>
            © 2023,&nbsp;
            <Text weight='bold' size='lg'>
              M-Verse
            </Text>
            .Co.Ltd
          </Text>
        </Footer>
      </Outer>
    </Wrap>
  )
}

export default ContactMobileComponent

const Wrap = styled.div``
const Footer = styled.div`
  position: absolute;
  bottom: 3%;
  left: 35px;
  right: 0;
  z-index: 21;
  color: white;

  .bottom-menu {
    margin-bottom: 15%;
    .link {
      color: #fff;

      &:active {
        color: #4d5876;
      }
    }
  }

  .info {
    margin-bottom: 5%;
  }
`

const MailList = styled.div`
  position: absolute;
  width: 100%;
  height: 25%;
  top: 59.5%;
  left: 0;

  & > a {
    display: block;
    padding-top: 1.4%;
    padding-left: 20%;
    height: 11.2%;
    line-height: 1;
    font-size: 3.2vw;

    & + a {
      margin-top: 5.4%;
    }
  }
`
